<template>
  <div>
    <div class="flex flex-col">
      <div class="py-[10px] flex justify-between font-caption-1">
        <span>{{ $t("appliedFilters.allTiers") }}</span>
        <span>{{ $t("appliedFilters.topTier") }}</span>
      </div>
      <SliderInput
        data-intercom-target="Publication Rank slider"
        :current-value="
          searchFilterStore?.currentSearchFilter?.filter_pagerank_min ?? 0
        "
        :on-change="update"
        @click.stop
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSearchFiltersStore } from "~/store/searchFilter";
import SliderInput from "~/components/shared/SliderInput.vue";

const searchFilterStore = useSearchFiltersStore();

const emit = defineEmits(["performUpdate"]);

const update = (value: number) => {
  searchFilterStore.updatePagerankMin(Number(value));
  emit("performUpdate");
};
</script>
